import { smartAxios } from "../axios/Axios";
import { marketPlaceEndpoints } from "./marketPlaceEndpoints";
import { IMarketPlace } from "./marketPlaceModel";

export const postMarketPlace = (data: IMarketPlace) => {
  return smartAxios.post(marketPlaceEndpoints.postMarketPlace, data);
};

export const postMarketPlaceForm = (formData: FormData) => {
  return smartAxios.post(marketPlaceEndpoints.postMarketPlace, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getMarketPlace = (page = 1, pageSize = 9) => {
  return smartAxios.get(marketPlaceEndpoints.getMarketPlace, {
    params: { page, page_size: pageSize },
  });
};
export const getMyBusinesses = (page = 1, pageSize = 9) => {
  return smartAxios.get(marketPlaceEndpoints.getMyBusinesses, {
    params: { page, page_size: pageSize },
  });
};

export const putMarketPlaceForm = (id: number, formData: FormData) => {
  return smartAxios.put(`${marketPlaceEndpoints.putMarketPlace}${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteMarketPlace = (id: number) => {
  return smartAxios.delete(`${marketPlaceEndpoints.deleteMarketPlace}${id}/`);
};
